var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import QueueFromPayload from 'components/powerFlowShared/components/queueFromPayload';
import { FlowNodeTypes, } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import { QueueModal as ActionModal } from '../modals/queue';
import styles from './queue.module.scss';
const portTranslator = (node) => {
    if (node.payload.queue_timeout) {
        const timeout = node.payload.queue_timeout;
        return [
            {
                connection: timeout.timeout_node_id || uuid(),
                id: uuid(),
                label: 'Timeout',
                type: 'out',
            },
        ];
    }
    return [];
};
export class QueueNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        return (_jsx(FlowNode, { color: QueueNode.color, icon: QueueNode.icon, label: QueueNode.label, text: _jsx(QueueFromPayload, { className: styles.text, extraData: this.props.extraData, hasSettings: true, node: this.props.node }), onEdit: this.triggerEdit }));
    }
}
QueueNode.height = FlowNode.dimensions.h + 32;
QueueNode.icon = 'users';
QueueNode.label = 'Queue';
QueueNode.helpText = 'The queue is where you’d like your incoming conversations to automatically end up based on your company’s structure and priorities (e.g. Sales, Support).';
QueueNode.color = flowNodeColor.green;
QueueNode.translatePayload = formatPortsHelper(portTranslator);
QueueNode.ActionModal = ActionModal;
QueueNode.actionTrigger = { type: FlowNodeTypes.QUEUE };
QueueNode.updateConnection = (node, _port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    if (payload.queue_timeout) {
        payload.queue_timeout.timeout_node_id = newConnection;
    }
    return Object.assign(Object.assign({}, node), { payload });
};
__decorate([
    boundMethod
], QueueNode.prototype, "triggerEdit", null);
